/* Cart: GST estimate under the total, and add-ons (sample kit, neck labels) above checkout.
   Works for the cart drawer and the cart page; re-applies when apps re-render the totals. */
(function () {
  var RATE = 0.05;
  var inr = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var num = function (t) { var m = (t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : null; };
  var extras = null, extrasFor = null, busy = false;

  function gst() {
    document.querySelectorAll('.totals').forEach(function (box) {
      var v = box.querySelector('.totals__total-value');
      var amt = v ? num(v.textContent) : null;
      var row = box.parentNode.querySelector('.ba-gst');
      if (amt === null || amt <= 0) { if (row) row.remove(); return; }
      var html = '<div><span>GST (5%)</span><span>' + inr(amt * RATE) + '</span></div>' +
                 '<div class="ba-gst__t"><span>Total with GST</span><span>' + inr(amt * (1 + RATE)) + '</span></div>';
      if (!row) { row = document.createElement('div'); row.className = 'ba-gst'; box.insertAdjacentElement('afterend', row); }
      if (row.getAttribute('data-a') !== String(amt)) { row.innerHTML = html; row.setAttribute('data-a', String(amt)); }
    });
  }

  function place() {
    if (extras === null) return;
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var host = ctas.parentNode, cur = host.querySelector('[data-ba-cx]');
      if (cur && cur.getAttribute('data-k') === extrasFor) return;
      if (cur) cur.remove();
      var d = document.createElement('div'); d.innerHTML = extras;
      var el = d.querySelector('[data-ba-cx]'); if (!el) return;
      el.setAttribute('data-k', extrasFor);
      host.insertBefore(el, ctas);
    });
  }

  function load() {
    if (busy) return; busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var key = c.item_count + ':' + c.items.map(function (i) { return i.handle; }).join(',');
      if (key === extrasFor) { busy = false; place(); return; }
      return fetch('/?section_id=ba-cart-extras').then(function (r) { return r.text(); }).then(function (h) {
        extras = h; extrasFor = key; busy = false; place();
      });
    }).catch(function () { busy = false; });
  }

  var t;
  function tick() { clearTimeout(t); t = setTimeout(function () { gst(); place(); }, 120); }
  document.addEventListener('DOMContentLoaded', function () {
    gst(); load();
    new MutationObserver(tick).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', function (e) { if (e.target.closest('cart-remove-button, .quantity__button, [name="add"], .ba-buy, form[action*="/cart/add"] button')) setTimeout(load, 900); });
    document.addEventListener('change', function (e) { if (e.target.closest('.quantity__input')) setTimeout(load, 900); });
  });
})();
